import config from '../../config';
import { getToken } from '../../utils';
export default function request(method, url, data) {
    if (data === void 0) { data = null; }
    var token = getToken();
    return fetch("" + config[process.env.API_ENV].apiUrl + url, {
        method: method,
        headers: {
            Authorization: "Bearer " + token,
        },
        body: data && JSON.stringify(data),
    }).then(function (response) {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response;
    });
}
export function get(url, data) {
    if (data === void 0) { data = null; }
    return request('GET', url, data).then(function (res) { return res.json(); });
}
export function post(url, data) {
    if (data === void 0) { data = {}; }
    return request('POST', url, data).then(function (res) { return res.json(); });
}
//# sourceMappingURL=request.js.map